import api from './api';

export const login    = (data) => api.post('/api/auth/login', data);
export const rsminLogin = (token) => api.post('/api/auth/rsmin-login', { token });
export const register = (data) => api.post('/api/auth/register', data);
export const getMe    = ()     => api.get('/api/auth/me');
export const changeMyPassword = (data) => api.post('/api/auth/me/password', data);
export const refreshTokens = (userId, refreshToken) =>
  api.post('/api/auth/refresh', { userId, refreshToken });
export const logoutApi = (userId) => api.post('/api/auth/logout', { userId });

// Full bootstrap payload: user + memberships + panel + allowedModules.
// Canonical call on app load and after every auth state change.
export const getBootstrap = () => api.get('/api/auth/bootstrap');
